module.exports = __webpack_public_path__ + "img/4042.9cf8c28b.svg";